import { createFeatureSelector, createSelector } from '@ngrx/store';
import { billingCoverFeatureKey } from '../reducers';
import { BillingCoverState } from '../reducers/billing-cover.reducer';

export const selectBillingCover = createFeatureSelector<BillingCoverState>(
  billingCoverFeatureKey
);

export const selectBillCoverByByAccountNumber = (accountNumber: string) =>
  createSelector(
    selectBillingCover,
    (state) => state.byAccountNumber[accountNumber]
  );

export const billCoverByDocumentReferenceSelector = (
  accountNumber: string,
  referenceNumber: string
) =>
  createSelector(
    selectBillCoverByByAccountNumber(accountNumber),
    (state) => state[referenceNumber]
  );
